import { StateCreator } from "zustand";
import { EphemeralStore } from "./useEphemeralStore";
import { StandardExpenseFormValues } from "feat/editItinerary/expenses/forms/expense-form-utils";

export type ExpenseAIFieldName = keyof Pick<
  StandardExpenseFormValues,
  "amount" | "category" | "currency" | "description" | "invoiceDate" | "merchant"
>;

export interface ExpenseAIField {
  name: ExpenseAIFieldName;
  value: string;
}

export type ExpenseAIFieldValues = Pick<
  StandardExpenseFormValues,
  "amount" | "category" | "currency" | "description" | "invoiceDate" | "merchant"
>;

export const EXPENSE_AI_FIELD_NAMES = [
  "amount",
  "category",
  "currency",
  "description",
  "invoiceDate",
  "merchant",
] as const satisfies readonly ExpenseAIFieldName[];

interface ExpenseAIResultState {
  expenseAIResult: ExpenseAIField[] | null;
  existingExpenseFormValues: ExpenseAIFieldValues | null;
}

interface ExpenseAIResultActions {
  setExpenseAIResult: (result: ExpenseAIField[] | null) => void;
  clearExpenseAIResult: () => void;
  setExistingExpenseFormValues: (result: ExpenseAIFieldValues | null) => void;
  clearExistingExpenseFormValues: () => void;
}

export interface ExpenseAIResultSlice extends ExpenseAIResultState, ExpenseAIResultActions {}

export const createExpenseAIResultSlice: StateCreator<EphemeralStore, [], [], ExpenseAIResultSlice> = (set) => ({
  expenseAIResult: null,
  existingExpenseFormValues: null,
  setExpenseAIResult: (result) => set({ expenseAIResult: result }),
  clearExpenseAIResult: () => set({ expenseAIResult: null }),
  setExistingExpenseFormValues: (result) => set({ existingExpenseFormValues: result }),
  clearExistingExpenseFormValues: () => set({ existingExpenseFormValues: null }),
});
